module.exports = __webpack_public_path__ + "static/media/comment-social-badge.67185e9b.svg";